import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadExpenseModalIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 97,
	height: 104,
	viewBox: "0 0 97 104",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_10602_65599)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M59.487 19.7064C59.487 16.1068 62.4054 13.1885 66.0049 13.1885C69.6045 13.1885 72.5229 16.1068 72.5229 19.7064V38.7247L78.0764 45.2342L59.644 45.1782L59.487 38.7275V19.7092V19.7064Z",
				fill: "url(#paint0_linear_10602_65599)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_10602_65599)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M30.3878 13.1884V2.77932C30.3878 2.38404 30.7074 2.06445 31.1026 2.06445H82.7078C83.1003 2.06445 83.4198 2.38124 83.4227 2.77652C83.4451 7.04331 83.5684 29.1566 83.4731 39.6554C83.4703 40.0675 83.4198 40.4796 83.3273 40.8805C83.2376 41.2729 83.1031 41.6514 82.9321 42.0158C82.761 42.3719 82.5536 42.7111 82.3153 43.0251C82.077 43.3362 81.8051 43.6222 81.5051 43.8773C81.2052 44.1324 80.88 44.3595 80.5323 44.5473C80.1819 44.7379 79.8119 44.8921 79.4278 45.0043C78.9736 45.136 78.5027 45.2173 78.0317 45.2341C77.5916 45.251 77.1514 45.2145 76.7197 45.1276C76.3328 45.0491 75.9516 44.9286 75.5899 44.7716C75.2339 44.6174 74.8947 44.424 74.5779 44.1969C74.2639 43.9726 73.9724 43.7175 73.7088 43.4344C73.4453 43.1512 73.2126 42.84 73.0136 42.5092C72.8118 42.1756 72.6463 41.8196 72.5174 41.4495C72.3856 41.0711 72.2959 40.6814 72.2483 40.2833C72.2202 40.0591 72.209 39.832 72.209 39.6077V19.8661C72.209 16.331 69.4617 13.3229 65.9294 13.1968C62.2205 13.065 59.1732 16.031 59.1732 19.7091",
				fill: "url(#paint1_linear_10602_65599)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter2_d_10602_65599)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.4486 49.3104C10.4478 49.3104 10.4472 49.3098 10.4472 49.309V22.0893C10.4472 17.1721 14.4336 13.1885 19.348 13.1885H66.0051C62.4055 13.1885 59.4872 16.1068 59.4872 19.7064L59.6442 38.7247V60.2157C59.6442 70.7493 59.7424 80.691 51.6044 87.1882C51.3875 87.3613 51.1145 87.4536 50.837 87.4536H4.2321C3.13671 87.4536 2.54794 86.1374 3.22559 85.2768C12.6173 73.3492 10.4501 61.7515 10.45 49.3118C10.45 49.311 10.4493 49.3104 10.4486 49.3104Z",
				fill: "url(#paint2_linear_10602_65599)"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.0587 45.0697H17.9998",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.0587 50.3324H17.9998",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9165 55.5956H17.9998",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19.1493,
			cy: 38.4184,
			r: 2.33976,
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter3_dii_10602_65599)",
			children: [/* @__PURE__ */ _jsx("ellipse", {
				cx: 64.5,
				cy: 71.4536,
				rx: 16.5,
				ry: 16,
				fill: "#F7F8FA",
				shapeRendering: "crispEdges"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M64.5 89.9536C74.9203 89.9536 83.5 81.7428 83.5 71.4536C83.5 61.1644 74.9203 52.9536 64.5 52.9536C54.0797 52.9536 45.5 61.1644 45.5 71.4536C45.5 81.7428 54.0797 89.9536 64.5 89.9536Z",
				stroke: "#C9C9C9",
				strokeOpacity: .2,
				strokeWidth: 5,
				shapeRendering: "crispEdges"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65 78.4536L65 65.4536",
			stroke: "#EF4444",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58 71.4536L65 64.4536L72 71.4536",
			stroke: "#EF4444",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_10602_65599",
				x: 56.9612,
				y: 11.294,
				width: 26.1671,
				height: 39.6236,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 1.26295,
						dy: 1.89443
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.89443 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10602_65599"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_10602_65599",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_10602_65599",
				x: 27.8618,
				y: .170025,
				width: 60.6988,
				height: 50.7515,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 1.26295,
						dy: 1.89443
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.89443 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10602_65599"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_10602_65599",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_10602_65599",
				x: .411107,
				y: 11.294,
				width: 70.6458,
				height: 81.8428,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 1.26295,
						dy: 1.89443
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.89443 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10602_65599"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_10602_65599",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_dii_10602_65599",
				x: 38.8,
				y: 47.2536,
				width: 57.4,
				height: 56.4,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_10602_65599"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 3,
						dy: 4
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10602_65599"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_10602_65599",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -2,
						dy: -2
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect2_innerShadow_10602_65599"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2,
						dy: 2
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_innerShadow_10602_65599",
						result: "effect3_innerShadow_10602_65599"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_10602_65599",
				x1: 76.7752,
				y1: 11.065,
				x2: 46.6145,
				y2: 35.6431,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF8C8C" }), /* @__PURE__ */ _jsx("stop", {
					offset: .355205,
					stopColor: "#EB3636"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_10602_65599",
				x1: 86.4262,
				y1: 20.6684,
				x2: 31.6134,
				y2: 52.5993,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF8C8C" }), /* @__PURE__ */ _jsx("stop", {
					offset: .470422,
					stopColor: "#EB3636"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_10602_65599",
				x1: 61.4816,
				y1: 8.2673,
				x2: -8.46927,
				y2: 93.7734,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF8C8C" }), /* @__PURE__ */ _jsx("stop", {
					offset: .562838,
					stopColor: "#EB3636"
				})]
			})
		] })
	]
});
export default SvgUploadExpenseModalIcon;
